package team.platforma.multiplatform_material_extension.ui.date

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import kotlinx.datetime.Clock
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format.DateTimeFormat
import kotlinx.datetime.format.FormatStringsInDatetimeFormats
import kotlinx.datetime.format.byUnicodePattern
import kotlinx.datetime.minus
import kotlinx.datetime.todayIn
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.ic24_mel_calendar
import materialextension.multiplatform_material_extension.generated.resources.mel_select_date
import org.jetbrains.compose.resources.StringResource
import team.platforma.multiplatform_material_extension.calendar.properties.DatePikerProperties
import team.platforma.multiplatform_material_extension.calendar.calendar_regular.dialog.DatePiker
import team.platforma.multiplatform_material_extension.calendar.utils.CalendarRange
import team.platforma.multiplatform_material_extension.calendar.utils.setStandardCalendarRange
import team.platforma.multiplatform_material_extension.ui.core.InputField
import team.platforma.multiplatform_material_extension.ui.core.InputFieldProperties
import team.platforma.multiplatform_material_extension.ui.core.InputFieldStateListener
import team.platforma.multiplatform_material_extension.ui.core.StyledTextField
import team.platforma.multiplatform_material_extension.ui.core.field_utils.endIcon
import team.platforma.multiplatform_material_extension.ui.core.global_style.area.supportArea
import team.platforma.multiplatform_material_extension.ui.core.global_style.setFiledTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.setOutlinedTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setFilledTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setOutlineTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.rememberInputFieldState
import team.platforma.multiplatform_material_extension.util.forms.FormProperties
import team.platforma.multiplatform_material_extension.util.forms.keyListener
import team.platforma.multiplatform_material_extension.util.forms.rememberForms
import team.platforma.multiplatform_material_extension.util.visual_transformation.MaskVisualTransformation


/**
 * Инициализация поля ввода даты
 * @author Evgeny Minaenkov
 * @see [DateField]
 * @sample dateFieldInitializeSample
 *
 */
@Deprecated("")
object DateField : InputField {
    @OptIn(FormatStringsInDatetimeFormats::class)
    @Composable
    fun create(
        modifier: Modifier? = null,
        localDate: LocalDate? = null,
        onLocalDateChange: (LocalDate?) -> Unit,
        datePikerTitle: StringResource = Res.string.mel_select_date,
        localDateFormat: DateTimeFormat<LocalDate> = LocalDate.Format { byUnicodePattern("dd.MM.yyyy") },
        mask: String = "##.##.####",
        maskChar: Char = '#',
        required: Boolean = true,
        dateInputMessage: DateInputMessage? = null,
        calendarRange: CalendarRange? = null,
        formProperties: FormProperties? = null,
//        dialogViewState: (Boolean) -> Unit = {}
    ): StyledTextField {

        val form by rememberForms()

        val mForm = formProperties ?: FormProperties(form, key = "")

        val currentDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
        val mCalendarRange = calendarRange ?: setStandardCalendarRange(currentDate)


        LaunchedEffect(mForm.key) {
//            val initializeDateString = localDate.toVisibleString(localDateFormat)

            mForm.form.initValue(mForm.key, localDate.toVisibleString(localDateFormat))
//            mForm.form.setRequired(mForm.key, required)
            mForm.form
                .changeValue(mForm.key, localDate.toVisibleString(localDateFormat))

        }



        return builder(
            DateFieldImpl(
                areaModifier = modifier,
                localDate = localDate,
                onLocalDateChange = {
                    onLocalDateChange.invoke(it)
                },
                localDateFormat = localDateFormat,
                mask = mask,
                maskChar = maskChar,
                required = required,
                dateInputMessage = dateInputMessage,
                calendarRange = mCalendarRange,
                form = mForm,
                datePikerTitle = datePikerTitle,
//                dialogState = { boolean: Boolean ->
//                    dialogViewState(boolean)
//                }
            )
        )
    }

    override fun builder(textFieldImpl: StyledTextField): StyledTextField = textFieldImpl

}


@Composable
private fun DateFieldImpl(
    areaModifier: Modifier?,
    localDate: LocalDate?,
    onLocalDateChange: (LocalDate?) -> Unit,
    localDateFormat: DateTimeFormat<LocalDate>,
    datePikerTitle: StringResource,
    mask: String,
    maskChar: Char,
    required: Boolean,
    dateInputMessage: DateInputMessage?,
    calendarRange: CalendarRange,
    form: FormProperties,
//    dialogState: (Boolean) -> Unit
): StyledTextField {

    val inputFieldState = rememberInputFieldState()

    val focusRequester = remember { FocusRequester() }
    val index = remember { form.form.registerFocus(focusRequester) }

    var showDatePiker by remember { mutableStateOf(false) }

//    LaunchedEffect(showDatePiker) {
//        dialogState(showDatePiker)
//    }

    var stringDate by remember { mutableStateOf(localDate.formatToInputString(localDateFormat)) }

    val visualTransformation = remember { MaskVisualTransformation(mask, maskChar) }

    var error by remember { mutableStateOf(false) }

    var showMessage by remember { mutableStateOf(false) }

    val mDateInputMessage = dateInputMessage ?: DateInputMessage()

    var message by remember { mutableStateOf(mDateInputMessage.help) }

//    val focusRequester = remember { FocusRequester() }

    LaunchedEffect(localDate) {
        val validate = when {
            localDate == null -> {
                if (required) {
                    showMessage = true
                    message = mDateInputMessage.required
                    false
                } else {
                    true
                }
            }

            localDate > calendarRange.min -> {
                error = true
                showMessage = true
                message = mDateInputMessage.afterMin
                    ?: "Максимально доступная дата ${localDateFormat.format(calendarRange.min)}"
                false
            }

            localDate < calendarRange.max -> {
                error = true
                showMessage = true
                message = mDateInputMessage.afterMin
                    ?: "Минимально доступная дата ${localDateFormat.format(calendarRange.max)}"
                false
            }

            localDate in calendarRange.max..calendarRange.min -> true
            else -> false
        }

        form.form.setValidateState(form.key, validate)
    }




    DisposableEffect(inputFieldState) {

        val listener = object : InputFieldStateListener {

            override fun onLocalDateChange(localDate: LocalDate) {
                error = false
                showMessage = false
                stringDate = localDate.formatToInputString(localDateFormat)
                onLocalDateChange.invoke(localDate)
                form.form.setValidateState(form.key, true)
                form.form.changeValue(
                    form.key,
                    visualTransformation.filter(AnnotatedString(stringDate)).text.text
                )
            }

            override fun onEndIconClick() {
//                focusRequester.requestFocus()
                showDatePiker = !showDatePiker
            }

            override fun onValueChange(string: String) {
                stringDate = string.take(mask.count { it == maskChar })

                form.form.changeValue(
                    form.key,
                    visualTransformation.filter(AnnotatedString(stringDate)).text.text
                )

                if (stringDate.length == mask.count { it == maskChar }) {

                    val resultStringDate =
                        visualTransformation.filter(AnnotatedString(stringDate)).text.text

                    val resultDate = resultStringDate.toLocalDate(localDateFormat)


                    // если дата null говорим что такой даты не существует
                    if (resultDate == null) {
                        message = mDateInputMessage.invalidDate
                        error = true
                        showMessage = true
                        onLocalDateChange.invoke(null)
                        form.form.setValidateState(form.key, false)
                    } else {
//                        error = false
//                        showMessage = false
                        // здесь еще нужно проверять на ренж календаря

                        when {
                            resultDate > calendarRange.min -> {
                                message = mDateInputMessage.afterMin
                                    ?: "Максимально доступная дата ${
                                        localDateFormat.format(
                                            calendarRange.min
                                        )
                                    }"
                                error = true
                                showMessage = true
                                onLocalDateChange.invoke(null)
                                form.form.setValidateState(form.key, false)
                            }

                            resultDate < calendarRange.max -> {
                                message = mDateInputMessage.beforeMax
                                    ?: "Минимально доступная дата ${
                                        localDateFormat.format(
                                            calendarRange.max
                                        )
                                    }"
                                error = true
                                showMessage = true
                                onLocalDateChange.invoke(null)
                                form.form.setValidateState(form.key, false)
                            }

                            resultDate in calendarRange.max..calendarRange.min -> {
                                error = false
                                showMessage = false
                                onLocalDateChange.invoke(resultDate)
                                form.form.setValidateState(form.key, true)
                            }
                        }

                    }


                } else if (stringDate.isEmpty()) {

                    // если дата пустая и обязательная говорим что поле обязательное
                    if (required) {
                        message = mDateInputMessage.required
                        error = true
                        showMessage = true
                        form.form.setValidateState(form.key, false)
                    } else {
                        error = false
                        showMessage = false
                        form.form.setValidateState(form.key, true)
                    }


                } else if (stringDate.isNotEmpty() && stringDate.length < mask.count { it == maskChar }) {
                    onLocalDateChange.invoke(null)
                    form.form.setValidateState(form.key, false)
                    message = mDateInputMessage.help
                    error = false
                    showMessage = true
                }
            }

        }

        inputFieldState.addListener(listener)

        onDispose {
            inputFieldState.removeListener(listener)
        }
    }

    if (showDatePiker) {
        DatePiker(
            onDismiss = { showDatePiker = !showDatePiker },
            value = localDate,
            onDateSelected = { selectedDate ->
                inputFieldState.changeLocalDate(selectedDate)
            },
            properties = DatePikerProperties(
                animateUserScroll = true,
                animateClickChangeButtonMonth = true,
                dismissOnBackPress = true,
                dismissOnClickOutside = true
            ),
            calendarRange = calendarRange,
            title = datePikerTitle
        )
    }


    val style = object : StyledTextField {
        @Composable
        override fun Outline(properties: InputFieldProperties?) {
            val mProperties = properties ?: InputFieldProperties()

            Column(
                modifier = (areaModifier ?: Modifier).width(IntrinsicSize.Min)
                    .heightIn(min = supportArea())
            ) {
                OutlinedTextField(
                    value = stringDate,
                    onValueChange = { change ->
                        inputFieldState.changeValue(change)
                    },
                    label = mProperties.label,
                    modifier = (mProperties.modifier ?: Modifier)
                        .keyListener(Key.Tab) {
                            form.form.moveToNextFocus(index)
                        }.focusRequester(focusRequester),
                    trailingIcon = {
                        endIcon(
                            drawableResource = mProperties.endIcon
                                ?: Res.drawable.ic24_mel_calendar,
                            inputFieldState = inputFieldState
                        )
                    },
                    visualTransformation = visualTransformation,
                    isError = error,
                    keyboardOptions = mProperties.keyboardOptions
                        ?: KeyboardOptions(keyboardType = KeyboardType.Number),
                    colors = properties?.colors ?: setOutlinedTextFieldDefaults(),
                    shape = properties?.shape ?: setOutlineTextFieldDefaultShape(),
                )
                Column(
                    modifier = Modifier.heightIn(min = supportArea()).fillMaxWidth()
                ){
                    AnimatedVisibility(showMessage) {
                        val helperTextColors = properties?.colors ?: setOutlinedTextFieldDefaults()
                        Text(
                            modifier = Modifier.padding(horizontal = 16.dp),
                            text = message,
                            color = if (error) helperTextColors.errorSupportingTextColor else helperTextColors.focusedSupportingTextColor,
                            style = MaterialTheme.typography.bodySmall
                        )
                    }
                }
            }
        }


        @Composable
        override fun Filled(properties: InputFieldProperties?) {
            val mProperties = properties ?: InputFieldProperties()

            Column(
                modifier = (areaModifier ?: Modifier).width(IntrinsicSize.Min)
            ) {
                TextField(
                    value = stringDate,
                    onValueChange = { change ->
                        inputFieldState.changeValue(change)
                    },
                    label = mProperties.label,
                    modifier = (mProperties.modifier ?: Modifier)
                        .keyListener(Key.Tab) {
                            form.form.moveToNextFocus(index)
                        }.focusRequester(focusRequester),
                    trailingIcon = {
                        endIcon(
                            drawableResource = mProperties.endIcon
                                ?: Res.drawable.ic24_mel_calendar,
                            inputFieldState = inputFieldState
                        )
                    },
                    visualTransformation = visualTransformation,
                    isError = error,
                    keyboardOptions = mProperties.keyboardOptions
                        ?: KeyboardOptions(keyboardType = KeyboardType.Number),
                    colors = properties?.colors ?: setFiledTextFieldDefaults(),
                    shape = properties?.shape ?: setFilledTextFieldDefaultShape(),
                )
                Column(
                    modifier = Modifier.heightIn(min = supportArea()).fillMaxWidth()
                ){
                    AnimatedVisibility(showMessage) {
                        val helperTextColors = properties?.colors ?: setFiledTextFieldDefaults()
                        Text(
                            modifier = Modifier.padding(horizontal = 16.dp),
                            text = message,
                            color = if (error) helperTextColors.errorSupportingTextColor else helperTextColors.focusedSupportingTextColor,
                            style = MaterialTheme.typography.bodySmall
                        )
                    }
                }
            }
        }

    }
    return style
}


private fun LocalDate?.formatToInputString(dateTimeFormat: DateTimeFormat<LocalDate>): String {
    return this?.let { date ->
        dateTimeFormat.format(date).replace(Regex("[^\\w\\s]"), "")
    } ?: ""
}

private fun LocalDate?.toVisibleString(dateTimeFormat: DateTimeFormat<LocalDate>): String {
    return try {
        this?.let { date ->
            dateTimeFormat.format(date)
        } ?: ""
    } catch (e: Exception) {
        ""
    }
}

private fun String.toLocalDate(dateTimeFormat: DateTimeFormat<LocalDate>): LocalDate? {
    return try {
        dateTimeFormat.parse(this)
    } catch (e: Exception) {
        null
    }
}


class DateInputMessage(
    val invalidDate: String = "Введена некоректная дата",
    val help: String = "Пример: 24.05.1993",
    val required: String = "Обязательное поле",
    val afterMin: String? = null,
    val beforeMax: String? = null
)


@Composable
internal fun dateFieldInitializeSample() {
    val currentDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
    val calendarRange = CalendarRange(
        min = currentDate.minus(DatePeriod(years = 18)),
        max = currentDate.minus(DatePeriod(years = 101))
    )

    var resultDate: LocalDate? = currentDate

    val form by rememberForms()

    DateField.create(
        localDate = currentDate,
        onLocalDateChange = {
            resultDate = it
        },
        calendarRange = calendarRange,
        formProperties = FormProperties(
            form = form,
            key = "simple_key"
        )
    ).Outline( // or Filled
        properties = InputFieldProperties().simpleLabel("Input field label")
    )
}

